
import { Component, Mixins } from "vue-property-decorator";
import { IHistoryRecord, IObjectNameIdentifier } from "../../../../../../documaker/domain/format/objects";
import { IInformationKeyHistoriesPropertyEditable, instanceOfIInformationKeyHistoriesPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class InformationKeyHistoriesPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IInformationKeyHistoriesPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IInformationKeyHistoriesPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isInformationKeyHistoriesEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIInformationKeyHistoriesPropertyEditable(s) && s.informationKeyHistories().isEditable(), false);
  }

  get informationKeyHistories(): IHistoryRecord<IObjectNameIdentifier>[] {
    return this.readPropertyOrDefault(s => s.informationKeyHistories().getValue(), []);
  }

  set informationKeyHistories(value: IHistoryRecord<IObjectNameIdentifier>[]) {
    this.writePropertyWhenValid(s => s.informationKeyHistories().setValue(value));
  }
}
